












import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { printCost } from "@/lib/moneyHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PaidVideoRequestConfirm",
  components: { BaseAvatar, BaseButton },
  props: {
    price: { type: Number },
    opponentUser: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    return {
      authUserStrict,
      printCost,
    };
  },
});
